'use client';
import React, { useState, useEffect } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

const TabsRender = ({ tabs, initialRouteName, screenOptions }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    if (initialRouteName) {
      const initialTabIndex = tabs.findIndex((tab) => tab.label === initialRouteName);
      if (initialTabIndex !== -1) {
        setSelectedIndex(initialTabIndex);
      }
    }
  }, [initialRouteName, tabs]);

  return (
    <Tabs selectedIndex={selectedIndex} onSelect={(index) => setSelectedIndex(index)}>
      <TabList
        style={{
          justifyContent: 'space-around',
          flexWrap: 'wrap',
          flexDirection: 'row',
          display: 'flex',
          ...screenOptions?.tabListStyle,
        }}
      >
        {tabs.map((tab, index) => (
          <Tab key={index} style={{ ...screenOptions?.tabStyle }}>
            {tab.label}
          </Tab>
        ))}
      </TabList>

      {tabs.map((tab, index) => (
        <TabPanel key={index} style={{ ...screenOptions?.tabPanelStyle }}>
          <tab.component />
        </TabPanel>
      ))}
    </Tabs>
  );
};

const createMaterialTopTabNavigator: () => any = () => {
  return <></>;
};

export { TabsRender, createMaterialTopTabNavigator };
